export default function AboutUs() {
  const stats = [
    { number: '20', label: 'Años de experiencia' },
    { number: '5000', label: 'Clientes satisfechos' },
    { number: '100', label: 'Valoración perfecta' }
  ];

  return (
    <section id="sobre-nosotros" className="min-h-[600px] flex flex-col md:flex-row">
      {/* Content Area */}
      <div className="w-full md:w-1/2 bg-[#FAFAF8] p-12 md:p-20 flex flex-col justify-center">
        <div className="inline-block mb-8">
          <span className="px-6 py-2 bg-[#A8B5A0] text-white text-xs font-bold tracking-wider rounded-full whitespace-nowrap">
            20 AÑOS DE EXPERIENCIA
          </span>
        </div>

        <h2 className="font-serif text-5xl md:text-6xl font-medium text-[#2C3E2F] leading-tight mb-8">
          20 años de bienestar en el corazón de Getafe
        </h2>

        <p className="text-lg text-gray-700 leading-relaxed mb-12 max-w-xl">
          En Masaje de Vida, creemos que un masaje no es un lujo, es una necesidad para tu salud. Situados en la calle Gral. Castaños, hemos creado un espacio donde la higiene, la profesionalidad y la calidez se unen para ofrecerte un servicio que nuestros clientes califican como "simplemente perfecto".
        </p>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center md:text-left">
              <div className="flex items-baseline justify-center md:justify-start">
                <span className="font-sans font-bold text-5xl md:text-6xl text-[#A8B5A0]">
                  {stat.number}
                </span>
                <span className="font-sans font-bold text-3xl text-[#A8B5A0] ml-1">
                  +
                </span>
              </div>
              <p className="text-sm text-gray-600 mt-2 whitespace-nowrap">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Decorative Area */}
      <div className="w-full md:w-1/2 bg-gradient-to-br from-[#A8B5A0]/30 to-[#A8B5A0]/60 relative overflow-hidden min-h-[400px] md:min-h-0">
        {/* Organic Shapes */}
        <div className="absolute top-10 left-10 w-64 h-64 bg-[#A8B5A0]/40 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-80 h-80 bg-[#8fa089]/50 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-white/20 rounded-full blur-2xl"></div>
        
        {/* Additional decorative elements */}
        <div className="absolute top-1/4 right-1/4 w-32 h-32 bg-[#A8B5A0]/30 rounded-3xl rotate-12"></div>
        <div className="absolute bottom-1/3 left-1/4 w-40 h-40 bg-white/30 rounded-full"></div>
      </div>
    </section>
  );
}
